import styles from './BureauEnquiryTable.module.scss';
import { EnquiryData } from '../../CreditBureauConstants';
import LoadingSpinner from '../../../../../../../../common/_custom/LoadingSpinner/LoadingSpinner';
import { BureauEnquiryTableProps } from '../../CreditBureauConstants';
import { COLORS } from '../../../../../../../../utils/constants/colors';
import { useAppSelector } from '../../../../../../../../app/hooks';

function BureauEnquiryTable({ data, loading, vendorType }: BureauEnquiryTableProps) {
    const bureauEnquiryHeaders = useAppSelector((state) => state.investor?.config?.tabConfigs?.creditBureau?.bureauEnquiryHeaders);

    const getHeaders = () => {
        return bureauEnquiryHeaders?.[vendorType] || [];
    };

    const getRowText = (row: EnquiryData, key: string) => {
        switch (key) {
            case 'dateOfEnquiry':
                return row.dateOfEnquiry || '';
            default:
                return row[key as keyof EnquiryData] || '-';
        }
    };

    return (
        <div className={styles.BureauEnquiryTableContainer}>
            {loading ? (
                <div className={styles.Loading}>
                    <LoadingSpinner height="40px" color={COLORS.PRIMARY_PURPLE} />
                </div>
            ) : (
                <>
                    <table className={styles.BureauEnquiryTable}>
                        <thead className={styles.TableHead}>
                            <tr className={styles.TableHeadRow}>
                                {getHeaders().map((header, i) => (
                                    <td key={`header-${i}`} className={styles.TableHeadRowItem}>
                                        {header?.name || ''}
                                    </td>
                                ))}
                            </tr>
                        </thead>
                        <tbody className={styles.TableBody}>
                            {data?.length > 0 ? (
                                data.map((row, rowIndex) => (
                                    <tr key={`row-${rowIndex}`} className={styles.TableBodyRow}>
                                        {getHeaders().map((header, columnIndex) => (
                                            <td key={`cell-${rowIndex}-${columnIndex}`} className={styles.TableBodyRowItem}>
                                                {getRowText(row, header.key)}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className={styles.NoData} colSpan={getHeaders().length || 1}>
                                        No enquiries done for the individual
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
}

export default BureauEnquiryTable;
